var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-home"},[_c('bannerAdmin',{attrs:{"page":"home"}}),_vm._m(0),_c('product',{attrs:{"path":"adminHome"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"msg-list"},[_c('h3',{staticClass:"list-title"},[_vm._v("列表管理")])])
}]

export { render, staticRenderFns }